import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useOSPulse } from '../hooks/useOSPulse';
import { useT } from '../i18n';

/* OSLiveStats — real counters from /api/pulse. Renders nothing until loaded. */

export default function OSLiveStats() {
  const pulse = useOSPulse();
  const { lang } = useT();
  const es = lang === 'es';
  if (!pulse?.counts) return null;

  const stats = [
    { v: pulse.counts.articles_published, l: es ? 'Artículos publicados' : 'Articles published' },
    { v: pulse.counts.social_packages, l: es ? 'Paquetes sociales' : 'Social packages' },
    { v: pulse.counts.posts_distributed, l: es ? 'Posts distribuidos' : 'Posts distributed' },
    { v: pulse.counts.os_events, l: es ? 'Eventos del sistema' : 'System events' },
  ];

  return (
    <section className="bg-neutral-950 text-white border-t border-white/[0.06]" data-testid="os-live-stats">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10 py-10">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="shrink-0 lg:max-w-[220px]">
            <p className="inline-flex items-center gap-2 text-[10.5px] tracking-[0.2em] uppercase font-bold text-emerald-300">
              <span className="relative flex w-2 h-2">
                <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-70" />
                <span className="relative w-2 h-2 rounded-full bg-emerald-400" />
              </span>
              {es ? 'Datos reales, ahora' : 'Real data, right now'}
            </p>
            <Link to="/os" className="mt-1.5 inline-flex items-center gap-1 text-[12.5px] font-semibold text-neutral-400 hover:text-[#F77F11] transition-colors duration-200" data-testid="os-live-stats-link">
              {es ? 'Ver el OS en vivo' : 'Watch the OS live'} <ArrowRight className="w-3 h-3" />
            </Link>
          </div>
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {stats.map((s) => (
              <div key={s.l} className="rounded-xl bg-white/[0.04] border border-white/10 px-4 py-3.5 text-center" data-testid="os-live-stat">
                {s.v > 0 ? (
                  <p className="text-2xl font-bold text-[#F77F11] tracking-[-0.02em]">{s.v.toLocaleString()}</p>
                ) : (
                  <p className="inline-flex items-center justify-center gap-1.5 text-[12.5px] font-semibold text-emerald-300 h-8" data-testid="os-live-stat-standby">
                    <span className="relative flex w-1.5 h-1.5">
                      <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-70" />
                      <span className="relative w-1.5 h-1.5 rounded-full bg-emerald-400" />
                    </span>
                    {es ? 'Online — en espera' : 'Online — standby'}
                  </p>
                )}
                <p className="text-[11px] text-neutral-500 mt-0.5">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
